import React from "react";
import { useSelector, shallowEqual } from "react-redux";

import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import Cancel from "@mui/icons-material/Cancel";
// import Search from "@mui/icons-material/Search";

import { feedEntitiesGeoByTypeSelector } from "orion-components/GlobalData/Selectors";
import { getDeviceStateHexColor } from "orion-components/GlobalData/DeviceState/utils";
import SpriteIcon from "orion-components/SharedComponents/SpriteIcon/SpriteIcon";
import { TargetingIcon, convertToUserTime } from "orion-components/SharedComponents";
import { getTranslation } from "orion-components/i18n";

const Checkpoints = ({
	checkpoints = [],
	dir,
	patrolId,
	removeCheckpoint,
	adminRole,
	statusColorOptions,
	isTemplate,
	timeFormat,
	locale,
	resource,
	generatePatrolStatusOptions
}) => {
	const devices = useSelector((state) => feedEntitiesGeoByTypeSelector("device")(state), shallowEqual) || {};
	const entities = Object.values(devices);
	const deviceTypes = useSelector((state) => state?.globalData?.deviceTypes ?? {});
	const deviceState = useSelector((state) => state?.globalData?.deviceState ?? {});

	const styles = {
		checkpoint: {
			display: "flex",
			alignItems: "center",
			padding: "7px 0",
			height: 40
		},
		name: {
			fontSize: 12,
			color: "#fff",
			...(dir === "rtl" && { textAlign: "right" })
		},
		status: (status) => ({
			fontSize: 10,
			color: "#B4B8BC",
			...(status && { color: statusColorOptions[status] })
		}),
		spriteIcon: {
			width: 26,
			height: 26,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			borderRadius: "5px",
			...(dir === "ltr" && { marginRight: 12 }),
			...(dir === "rtl" && { marginLeft: 12 })
		},
		iconButton: {
			color: "#fff",
			padding: "unset",
			position: "absolute",
			...(dir === "rtl" ? { left: 20 } : { right: 20 })
		},
		cancel: {
			fontSize: 15
		},
		search: {
			fontSize: 15,
			opacity: 0.3
		},
		divider: {
			backgroundColor: "rgba(255, 255, 255, 0.1)"
		},
		iconContainerStyle: {
			padding: "unset",
			...(dir === "ltr" && { marginRight: 20 }),
			...(dir === "rtl" && { marginLeft: 20 })
		}
	};

	const generateCheckpoints = () => {
		return checkpoints.map((checkpoint, index) => {
			const entity =
				checkpoint.type === "device"
					? entities.find((entity) => entity.id === checkpoint.deviceId)
					: checkpoint;
			const name = entity?.name || entity?.entityData?.properties?.name || checkpoint?.name;
			const { geometry } = entity?.entityData || {};
			const icon = deviceTypes[entity?.deviceType]?.icon;
			const iconColor = getDeviceStateHexColor(deviceState[entity?.entityData?.properties?.deviceState]?.color);
			const formattedCompletionTime = checkpoint.completionTime
				? convertToUserTime(checkpoint.completionTime, timeFormat, locale)
				: "";
			const resourceName =
				formattedCompletionTime && resource ? `${resource?.firstName} ${resource?.lastName}` : "";
			const status = ["OVERDUE_DURATION", "OVERDUE_START"].includes(checkpoint?.status)
				? "OVERDUE"
				: checkpoint?.status || "";

			return (
				<div style={{ padding: "0 7px" }} key={index}>
					<div key={index} style={styles.checkpoint}>
						<div style={{ display: "flex", width: "60%" }}>
							{geometry && (
								<TargetingIcon
									id={entity?.id}
									feedId={entity?.feedId}
									geometry={geometry}
									iconContainerStyle={styles.iconContainerStyle}
									customStyles={{ width: 18, height: 18 }}
								/>
							)}
							{icon && (
								<div style={{ ...styles.spriteIcon, backgroundColor: iconColor || "#6A6C70" }}>
									<SpriteIcon iconName={icon} customWidth="14px" customHeight="14px" />
								</div>
							)}
							<Typography style={styles.name}>{name}</Typography>
						</div>
						{!isTemplate && (
							<>
								<div style={{ margin: "0 7px" }}>
									<Typography style={styles.status()}>{resourceName}</Typography>
									<Typography style={styles.status(status)}>
										{getTranslation(
											`global.profiles.widgets.patrols.patrolCard.${status}`
										)}{" "}
										<span style={styles.status()}>{formattedCompletionTime}</span>
									</Typography>
								</div>
								<div>
									{generatePatrolStatusOptions(
										checkpoint.status,
										null,
										true,
										patrolId,
										checkpoint.id
									)}
								</div>
							</>
						)}
						{adminRole && isTemplate && (
							<IconButton
								style={styles.iconButton}
								onClick={() => removeCheckpoint(patrolId, checkpoint.id)}
							>
								<Cancel style={styles.cancel} />
							</IconButton>
						)}
						{/* {operatorRole && <IconButton
                            style={styles.iconButton}
                            onClick={() => { }}
                        >
                            <Search style={styles.search} />
                        </IconButton>} */}
					</div>
					{index !== checkpoints.length - 1 && <Divider style={styles.divider} />}
				</div>
			);
		});
	};

	return <div>{generateCheckpoints()}</div>;
};

export default Checkpoints;
